<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        ref="Modal"
        hide-header
    >
        <rkm-area
            title="Identificação"
            type="fieldset"
            no-margin-top
        >

            <rkm-row>
                <rkm-col cols="6">
                    <strong>Nome:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.pacienteNome"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <strong>Data de nascimento:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.dataNascimento"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <strong>Prontuário:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.prontuario"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <strong>CNS:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.cns ? formatCns(pacienteInfo.cns) : ''"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <strong>RG:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.rg ? formatRg(pacienteInfo.rg) : ''"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <strong>CPF:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.cpf ? formatCpf(pacienteInfo.cpf) : ''"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <strong>Nome da mãe:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.nomeMae"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <strong>Tipo logradouro:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.logradouroTipo"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <strong>Endereço:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.endereco"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <strong>Bairro:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.bairro"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <strong>CEP:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.cep ? formatCep(pacienteInfo.cep) : ''"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="5">
                    <strong>Município residência:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.municipio"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="1">
                    <strong>UF:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.uf"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <strong>Unidade:</strong>
                    <rkm-form-input
                        :value="pacienteInfo.unidadeReferencia"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

        </rkm-area>
    </rkm-modal>
</template>

<script>

// Mixins.
import { formats } from '@/mixins'

export default {
    data: () => ({
        index: null,
        item: null,
        items: [],
        pacienteInfo: {
            pacienteNome: null,
            prontuario: null,
            cns: null,
            rg: null,
            cpf: null,
            nomeMae: null,
            logradouroTipo: null,
            endereco: null,
            bairro: null,
            cep: null,
            municipio: null,
            uf: null,
            unidadeReferencia: null,
        }
    }),
    methods: {
        open(item) {

            this.pacienteInfo.pacienteNome = item.pacienteNome
            this.pacienteInfo.dataNascimento = item.dataNascimento
            this.pacienteInfo.prontuario = item.prontuario
            this.pacienteInfo.cns = item.cns
            this.pacienteInfo.rg = item.rg
            this.pacienteInfo.cpf = item.cpf
            this.pacienteInfo.nomeMae = item.nomeMae
            this.pacienteInfo.logradouroTipo = item.logradouroTipo
            this.pacienteInfo.endereco = item.endereco
            this.pacienteInfo.bairro = item.bairro
            this.pacienteInfo.cep = item.cep
            this.pacienteInfo.municipio = item.municipio
            this.pacienteInfo.uf = item.uf
            this.pacienteInfo.unidadeReferencia = item.unidadeReferencia
            this.items = [],
            this.item = item

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
    },
    mixins: [formats],
    props: {
        data: { type: Object },
    }
}
</script>